<div class="newsletter-block">
  <h2 class="common-section-title newsletter-block__title theme-newsletter__title theme-newsletter__title-hover">
    {{ lg.newsletterBlock.heading }}
  </h2>
  <p class="newsletter-block__descr theme-newsletter__text">{{ lg.newsletterBlock.getDescription(beatmakerName) }}</p>
  <bmcore-newsletter-form class="newsletter-block__form" [beatmakerId]="beatmakerId"> </bmcore-newsletter-form>
</div>
